import { Page } from '@/core/architecture'

import { NotFoundWebTemplate } from './template'

export const NotFoundWeb: Page = () => {
  return <NotFoundWebTemplate />
}
